import { useSelector } from 'react-redux';
import { getSelectedPane } from '.';

export const useSelectedPane = () => useSelector(getSelectedPane);
